import { Injectable } from "@nestjs/common";
import { PayrollProcessRepository } from "./repository/payroll-process.repo";
import { PayrollLogsRepository } from "./repository/payroll-logs.repo";
import { PayrollComponentsLogs } from "./entity/payroll-process-logs.entity";
import { PayrollComponents } from "./entity/payroll-process.entity";
import { PayrollComponentsDto } from "./dto/payroll-process.dto";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { getManager, In, Repository } from "typeorm";
import appSettings from "apps/services/config";
import { NormalPayslipReq, PayRollMonthDto } from "@gtpl/shared-models/hrms";
import { PayRollRequest } from "@gtpl/shared-models/hrms";
import { PayrollLogs } from "./entity/payroll-log";
import { AttendanceRepository } from "../attendance/repository/attendance.repository";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { InjectRepository } from "@nestjs/typeorm";
import { DeductionsColumn } from "@gtpl/shared-models/hrms";
import { EmployeeIdReq } from "./dto/employee-id.req";
import { PayslipProcessRepository } from "./repository/payslip.repo";
import { PayrollComponentLogsRepository } from "./repository/payroll-component-process.repo";
import { employeeIdRequest } from "@gtpl/shared-models/gtpl";
import moment from "moment";




@Injectable()
export class PayrollProcessService {
    constructor(
        private payrollProcessRepo: PayrollProcessRepository,
        private payrollLogsRepo: PayrollLogsRepository,
        private attendanceRepo: AttendanceRepository,
        private payslipRepo: PayslipProcessRepository,
        private payRollComponentLog: PayrollComponentLogsRepository
    ) { }


    async createPayroll(createDto: PayrollComponentsDto): Promise<CommonResponse> {
        console.log(createDto, 'dtoooooo')
        const empData = await this.payrollProcessRepo.findOne({ where: { employeeId: createDto.employeeId } })
        console.log(empData, '1111111111')
        if (empData) {
            if (createDto.hraAmount != 0) {
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { hraAmount: createDto.hraAmount, updatedUser: createDto.userName })
                if (update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'hra'
                    entity.type = "A"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.hraAmount
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.eduAmount != 0) {
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { eduAmount: createDto.eduAmount, updatedUser: createDto.userName })
                if (update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'edu'
                    entity.type = "A"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.eduAmount
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.medicalAmount != 0) {
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { medicalAmount: createDto.medicalAmount, updatedUser: createDto.userName })
                if (update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'medicalAmount'
                    entity.type = "A"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.medicalAmount
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.splAmount != 0) {
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { splAmount: createDto.splAmount, updatedUser: createDto.userName })
                if (update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'Spl'
                    entity.type = "A"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.splAmount
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.conveyanceAmount != 0) {
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { conveyanceAmount: createDto.conveyanceAmount, updatedUser: createDto.userName })
                if (update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'conveyanceAmount'
                    entity.type = "A"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.conveyanceAmount
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.petrolAmount != 0) {
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { petrolAmount: createDto.petrolAmount, updatedUser: createDto.userName })
                if (update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'petrolAmount'
                    entity.type = "A"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.petrolAmount
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.shoeAmount != 0) {
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { shoeAmount: createDto.shoeAmount, updatedUser: createDto.userName })
                if (update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'shoeAmount'
                    entity.type = "A"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.shoeAmount
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.washingAmount != 0) {
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { washingAmount: createDto.washingAmount, updatedUser: createDto.userName })
                if (update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'washingAmount'
                    entity.type = "A"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.washingAmount
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.uniformAmount != 0) {
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { uniformAmount: createDto.uniformAmount, updatedUser: createDto.userName })
                if (update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'uniformAmount'
                    entity.type = "A"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.uniformAmount
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.helperAmount != 0) {
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { helperAmount: createDto.helperAmount, updatedUser: createDto.userName })
                if (update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'helperAmount'
                    entity.type = "A"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.helperAmount
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.productionAmount != 0) {
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { productionAmount: createDto.productionAmount, updatedUser: createDto.userName })
                if (update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'productionAmount'
                    entity.type = "A"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.productionAmount
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.taAmount != 0) {
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { taAmount: createDto.taAmount, updatedUser: createDto.userName })
                if (update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'taAmount'
                    entity.type = "A"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.taAmount
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.bonusAmount != 0) {
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { bonusAmount: createDto.bonusAmount, updatedUser: createDto.userName })
                if (update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'bonusAmount'
                    entity.type = "A"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.bonusAmount
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.messAmount != 0) {
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { messAmount: createDto.messAmount, updatedUser: createDto.userName })
                if (update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'messAmount'
                    entity.type = "D"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.messAmount
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.othersAmount != 0) {
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { othersAmount: createDto.othersAmount, updatedUser: createDto.userName })
                if (update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'othersAmount'
                    entity.type = "D"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.othersAmount
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            }
            else if (createDto.basic != 0) {
                const manager = getManager()
                const update = await this.payrollProcessRepo.update({ employeeId: createDto.employeeId }, { basic: createDto.basic, updatedUser: createDto.userName })
                const dataquery = `UPDATE ` + appSettings.masters_db + `.employee_details SET salary = ${createDto.basic} WHERE employee_id = ${createDto.employeeId}`;
                const res = await manager.query(dataquery)
                if (res && update.affected) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'basic'
                    entity.type = "A"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.amount = createDto.basic
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            }
        } else {
            if (createDto.hraAmount != 0) {
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.hraAmount = createDto.hraAmount
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                if (saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'hra'
                    entity.type = "A"
                    entity.amount = createDto.hraAmount
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.eduAmount != 0) {
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.eduAmount = createDto.eduAmount
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                if (saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'eduAmount'
                    entity.type = "A"
                    entity.amount = createDto.eduAmount
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.medicalAmount != 0) {
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.medicalAmount = createDto.medicalAmount
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                if (saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'medicalAmount'
                    entity.type = "A"
                    entity.amount = createDto.medicalAmount
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.splAmount != 0) {
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.splAmount = createDto.splAmount
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                if (saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'spl'
                    entity.type = "A"
                    entity.amount = createDto.splAmount
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.conveyanceAmount != 0) {
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.conveyanceAmount = createDto.conveyanceAmount
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                if (saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'conveyanceAmount'
                    entity.type = "A"
                    entity.amount = createDto.conveyanceAmount
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.petrolAmount != 0) {
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.petrolAmount = createDto.petrolAmount
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                if (saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'petrolAmount'
                    entity.type = "A"
                    entity.amount = createDto.petrolAmount
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.shoeAmount != 0) {
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.shoeAmount = createDto.shoeAmount
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                if (saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'shoeAmount'
                    entity.type = "A"
                    entity.amount = createDto.shoeAmount
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.washingAmount != 0) {
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.washingAmount = createDto.washingAmount
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                if (saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'washingAmount'
                    entity.type = "A"
                    entity.amount = createDto.washingAmount
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.uniformAmount != 0) {
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.uniformAmount = createDto.uniformAmount
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                if (saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'uniformAmount'
                    entity.type = "A"
                    entity.amount = createDto.uniformAmount
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.helperAmount != 0) {
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.helperAmount = createDto.helperAmount
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                if (saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'helperAmount'
                    entity.type = "A"
                    entity.amount = createDto.helperAmount
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.productionAmount != 0) {
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.productionAmount = createDto.productionAmount
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                if (saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'productionAmount'
                    entity.type = "A"
                    entity.amount = createDto.productionAmount
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.taAmount != 0) {
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.taAmount = createDto.taAmount
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                if (saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'taAmount'
                    entity.type = "A"
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    entity.amount = createDto.taAmount
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.bonusAmount != 0) {
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.bonusAmount = createDto.bonusAmount
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                if (saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'bonusAmount'
                    entity.type = "A"
                    entity.amount = createDto.bonusAmount
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.messAmount != 0) {
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.messAmount = createDto.messAmount
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                if (saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'messAmount'
                    entity.type = "D"
                    entity.amount = createDto.messAmount
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            } else if (createDto.othersAmount != 0) {
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.othersAmount = createDto.othersAmount
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                if (saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'othersAmount'
                    entity.type = "D"
                    entity.amount = createDto.othersAmount
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            }
            else if (createDto.basic != 0) {
                const manager = getManager()
                const entity = new PayrollComponents()
                entity.employeeId = createDto.employeeId
                entity.employeeName = createDto.employeeName
                entity.employeeCode = createDto.employeeCode
                entity.employeeType = createDto.employeeType
                entity.employeeCategory = createDto.employeeCategory
                entity.designation = createDto.designation
                entity.department = createDto.department
                entity.unitId = createDto.unitId
                entity.basic = createDto.basic
                entity.createdUser = createDto.userName
                const saved = await this.payrollProcessRepo.save(entity)
                const dataquery = `UPDATE ` + appSettings.masters_db + `.employee_details SET salary = ${createDto.basic} WHERE employee_id = ${createDto.employeeId}`;
                const res = await manager.query(dataquery)
                if (res && saved) {
                    const entity = new PayrollComponentsLogs();
                    entity.transactionName = 'basic'
                    entity.type = "A"
                    entity.amount = createDto.basic
                    entity.employeeId = createDto.employeeId
                    entity.employeeName = createDto.employeeName
                    entity.employeeCode = createDto.employeeCode
                    entity.employeeType = createDto.employeeType
                    entity.employeeCategory = createDto.employeeCategory
                    entity.designation = createDto.designation
                    entity.department = createDto.department
                    entity.unitId = createDto.unitId
                    entity.createdUser = createDto.userName
                    await this.payRollComponentLog.save(entity);
                }
            }
        }
        return new CommonResponse(true, 1, 'Saved successfully')
    }



    async getPayrollComponentsData(): Promise<CommonResponse> {
        try {
            // Assuming `appSettings.hrms_db` is accessible here and properly defined.
            let dataQuery = `SELECT 
                                employee_id as employeeId, 
                                basic as basic, 
                                hra_amount as hraAmount,
                                edu_amount as eduAmount,
                                medical_amount as medicalAmount,
                                spl_amount as splAmount,
                                conveyance_amount as conveyanceAmount, 
                                petrol_amount as petrolAmount,
                                shoe_amount as shoeAmount, 
                                washing_amount as washingAmount, 
                                uniform_amount as uniformAmount,
                                helper_amount as helperAmount, 
                                production_amount as productionAmount, 
                                ta_amount as taAmount,
                                bonus_amount as bonusAmount, 
                                tds as tds,
                                mess_d as messAmount, 
                                others_d as othersAmount,
                                employee_name as employeeName, 
                                employee_code as employeeCode,
                                des.designation, 
                                dep.dept_name as departmentName, 
                                employee_type as employeeType
                            FROM payroll_components pc
                            LEFT JOIN ${appSettings.hrms_db}.designation des 
                            ON des.designation_id = pc.designation
                            LEFT JOIN ${appSettings.masters_db}.departments dep ON dep.dept_id = pc.department`;

            const rawData = await this.payrollProcessRepo.query(dataQuery);
            return new CommonResponse(true, 233, 'Data retrieved successfully', rawData);
        } catch (error) {
            throw error;
        }
    }

    // async saveEmployeePayrollComponent(reqObj: any): Promise<CommonResponse> {
    //     console.log(reqObj,'reqqqqqqqqqqqq')
    //     try {
    //         const existedRec = await this.payrollProcessRepo.findOne({ where: { employeeId: reqObj.employeeId } });
    //         let entity: PayrollComponents;

    //         if (existedRec) {
    //             entity = existedRec;
    //         } else {
    //             entity = new PayrollComponents();
    //         }

    //         entity.employeeId = reqObj.employeeId;
    //         entity.basic = reqObj.basic;
    //         entity.hraAmount = reqObj.hraAmount;
    //         entity.eduAmount = reqObj.eduAmount;
    //         entity.medicalAmount = reqObj.medicalAmount;
    //         entity.splAmount = reqObj.splAmount;
    //         entity.conveyanceAmount = reqObj.conveyanceAmount;
    //         entity.petrolAmount = reqObj.petrolAmount;
    //         entity.shoeAmount = reqObj.shoeAmount;
    //         entity.washingAmount = reqObj.washingAmount;
    //         entity.uniformAmount = reqObj.uniformAmount;
    //         entity.helperAmount = reqObj.helperAmount;
    //         entity.productionAmount = reqObj.productionAmount;
    //         entity.messAmount = reqObj.messAmount;
    //         entity.othersAmount = reqObj.othersAmount;
    //         entity.bonusAmount = reqObj.bonusAmount


    //         const saved = await this.payrollProcessRepo.save(entity);

    //         return new CommonResponse(true, 6898, 'Data updated successfully', saved)
    //     } catch (error) {
    //         return new CommonResponse(false, 88, `Error saving payroll component: ${error.message}`);
    //     }
    // }


    async saveEmployeePayrollComponent(reqObj: any): Promise<CommonResponse> {
        console.log(reqObj, 'Received Request Object');
        const transactionManager = new GenericTransactionManager();

        try {
            await transactionManager.startTransaction();

            const existedRec = await this.payrollProcessRepo.findOne({ where: { employeeId: reqObj.employeeId } });
            let entity: PayrollComponents;
            const logs: PayrollComponentsLogs[] = [];

            if (existedRec) {
                entity = existedRec;
            } else {
                entity = new PayrollComponents();
                entity.employeeId = reqObj.employeeId;
                entity.employeeName = reqObj.employeeName;
                entity.employeeCode = reqObj.employeeCode;
                entity.employeeType = reqObj.employeeType;
                entity.employeeCategory = reqObj.employeeCategory;
                entity.designation = reqObj.designation;
                entity.department = reqObj.department;
                entity.unitId = reqObj.unitId;
            }

            const allowanceFields = [
                'basic', 'hraAmount', 'eduAmount', 'medicalAmount', 'splAmount',
                'conveyanceAmount', 'petrolAmount', 'shoeAmount', 'washingAmount',
                'uniformAmount', 'helperAmount', 'productionAmount', 'bonusAmount'
            ];

            const deductionFields = [
                'messAmount', 'othersAmount'
            ];

            const fieldsToUpdate = [...allowanceFields, ...deductionFields];
            for (const field of fieldsToUpdate) {
                if (reqObj[field] !== undefined && reqObj[field] !== entity[field]) {
                    const log = new PayrollComponentsLogs();
                    console.log(reqObj.employeeId, 'reqObj.employeeId')
                    log.employeeId = reqObj.employeeId;
                    log.employeeName = existedRec ? existedRec.employeeName : reqObj.employeeName;
                    log.employeeCode = existedRec ? existedRec.employeeCode : reqObj.employeeCode;
                    log.employeeType = existedRec ? existedRec.employeeType : reqObj.employeeType;
                    log.employeeCategory = existedRec ? existedRec.employeeCategory : reqObj.employeeCategory;
                    log.designation = existedRec ? existedRec.designation : reqObj.designation;
                    log.transactionName = field
                    log.type = allowanceFields.includes(field) ? 'A' : 'D';
                    log.amount = reqObj[field];
                    logs.push(log);
                    entity[field] = reqObj[field];
                }
            }

            const savedEntity = await transactionManager.getRepository(PayrollComponents).save(entity);
            const savedLogs = await transactionManager.getRepository(PayrollComponentsLogs).save(logs);

            await transactionManager.completeTransaction();

            return new CommonResponse(true, 6898, 'Data updated successfully', { savedEntity, savedLogs });
        } catch (error) {
            await transactionManager.releaseTransaction();
            return new CommonResponse(false, 88, `Error saving payroll component: ${error.message}`);
        }
    }



    // async DeductionExcelUpload(formData: any): Promise<CommonResponse> {
    //     console.log(formData, 'Received Form Data');
    //     const transactionManager = new GenericTransactionManager();
    //     try {
    //         await transactionManager.startTransaction();
    //         const flag = new Set<boolean>();
    //         const columnArray = [];
    //         const requiredColumns = ["EmployeeCode", "MessAmount", "OthersAmount"]; // Required columns for validation

    //         const updatedArray = formData.map((obj) => {
    //             const updatedObj = {};
    //             for (const key in obj) {
    //                 const newKey = key
    //                     .replace(/\s/g, '')
    //                     .replace(/[\(\)\.]/g, '')
    //                     .replace(/-/g, '');
    //                 if (newKey != '') {
    //                     columnArray.push(newKey);
    //                     updatedObj[newKey] = obj[key];
    //                 }
    //             }
    //             return updatedObj;
    //         });

    //         // Check for missing columns
    //         for (const column of requiredColumns) {
    //             if (!columnArray.includes(column)) {
    //                 await transactionManager.releaseTransaction();
    //                 return new CommonResponse(false, 1111, `Missing required column: ${column}`);
    //             }
    //         }

    //         const convertedData = updatedArray.map((obj) => {
    //             const updatedObj = {};
    //             for (const key in obj) {
    //                 const value = obj[key];
    //                 if (value === '') {
    //                     updatedObj[key] = null;
    //                 } else {
    //                     updatedObj[key] = value;
    //                 }
    //             }
    //             return updatedObj;
    //         });

    //         // Validate each row
    //         for (const data of convertedData) {
    //             if (!data.EmployeeCode) {
    //                 await transactionManager.releaseTransaction();
    //                 return new CommonResponse(false, 1112, 'Missing EmployeeCode in one of the rows');
    //             }
    //             if (data.MessAmount != null && typeof data.MessAmount !== 'number') {
    //                 await transactionManager.releaseTransaction();
    //                 return new CommonResponse(false, 1113, 'Invalid MessAmount value');
    //             }
    //             if (data.OthersAmount != null && typeof data.OthersAmount !== 'number') {
    //                 await transactionManager.releaseTransaction();
    //                 return new CommonResponse(false, 1114, 'Invalid OthersAmount value');
    //             }
    //         }

    //         for (const data of convertedData) {
    //             if (data.EmployeeCode != null) {
    //                 const existedData = await this.payrollProcessRepo.findOne({
    //                     where: {
    //                         employeeCode: data.EmployeeCode,
    //                     },
    //                 });
    //                 if (existedData) {
    //                     const update = await transactionManager
    //                         .getRepository(PayrollComponents)
    //                         .update({ id: existedData.id }, {
    //                             messAmount: data.MessAmount,
    //                             othersAmount: data.OthersAmount
    //                         });
    //                     if (!update.affected) {
    //                         flag.add(false);
    //                         await transactionManager.releaseTransaction();
    //                         return new CommonResponse(
    //                             false,
    //                             0,
    //                             'Something went wrong in updating the existing record'
    //                         );
    //                     } else {
    //                         const messLog = new PayrollComponentsLogs();
    //                         messLog.employeeId = existedData.employeeId;
    //                         messLog.employeeName = existedData.employeeName;
    //                         messLog.employeeCode = existedData.employeeCode;
    //                         messLog.employeeType = existedData.employeeType;
    //                         messLog.employeeCategory = existedData.employeeCategory;
    //                         messLog.designation = existedData.designation;
    //                         messLog.transactionName = 'Mess Amount';
    //                         messLog.type = 'D';
    //                         messLog.amount = data.MessAmount;

    //                         const othersLog = new PayrollComponentsLogs();
    //                         othersLog.employeeId = existedData.employeeId;
    //                         othersLog.employeeName = existedData.employeeName;
    //                         othersLog.employeeCode = existedData.employeeCode;
    //                         othersLog.employeeType = existedData.employeeType;
    //                         othersLog.employeeCategory = existedData.employeeCategory;
    //                         othersLog.designation = existedData.designation;
    //                         othersLog.transactionName = 'Others Amount';
    //                         othersLog.type = 'D';
    //                         othersLog.amount = data.OthersAmount;

    //                         const logsSaved = await transactionManager
    //                             .getRepository(PayrollComponentsLogs)
    //                             .save([messLog, othersLog]);

    //                         if (logsSaved) {
    //                             flag.add(true);
    //                         } else {
    //                             flag.add(false);
    //                             await transactionManager.releaseTransaction();
    //                             break;
    //                         }
    //                     }
    //                 } else {
    //                     flag.add(false);
    //                     await transactionManager.releaseTransaction();
    //                     return new CommonResponse(false, 0, 'Employee code not found in the database');
    //                 }
    //             }
    //         }

    //         if (!flag.has(false)) {
    //             await transactionManager.completeTransaction();
    //             return new CommonResponse(true, 1, 'Data saved successfully');
    //         } else {
    //             await transactionManager.releaseTransaction();
    //             return new CommonResponse(false, 0, 'Something went wrong');
    //         }
    //     } catch (err) {
    //         await transactionManager.releaseTransaction();
    //         return new CommonResponse(false, 0, 'Something went wrong');
    //     }
    // }

    async DeductionExcelUpload(formData: any): Promise<CommonResponse> {
        console.log(formData, 'Received Form Data');
        const transactionManager = new GenericTransactionManager();
        const missingEmployeeCodes: string[] = [];
        try {
            await transactionManager.startTransaction();
            const flag = new Set<boolean>();
            const columnArray = [];
            const requiredColumns = ["EmployeeCode", "MessAmount", "OthersAmount"]; // Required columns for validation

            const updatedArray = formData.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const newKey = key
                        .replace(/\s/g, '')
                        .replace(/[\(\)\.]/g, '')
                        .replace(/-/g, '');
                    if (newKey != '') {
                        columnArray.push(newKey);
                        updatedObj[newKey] = obj[key];
                    }
                }
                return updatedObj;
            });

            // Check for missing columns
            for (const column of requiredColumns) {
                if (!columnArray.includes(column)) {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 1111, `Missing required column: ${column}`);
                }
            }

            const convertedData = updatedArray.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const value = obj[key];
                    updatedObj[key] = value === '' ? null : value;
                }
                return updatedObj;
            });

            // Validate each row
            for (const data of convertedData) {
                if (!data.EmployeeCode) {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 1112, 'Missing EmployeeCode in one of the rows');
                }
                if (data.MessAmount != null && typeof data.MessAmount !== 'number') {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 1113, 'Invalid MessAmount value');
                }
                if (data.OthersAmount != null && typeof data.OthersAmount !== 'number') {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 1114, 'Invalid OthersAmount value');
                }
            }


            await transactionManager.getRepository(PayrollComponents).update(
                {},
                { messAmount: 0, othersAmount: 0 }
            );

            for (const data of convertedData) {
                if (data.EmployeeCode != null) {
                    const existedData = await this.payrollProcessRepo.findOne({
                        where: { employeeCode: data.EmployeeCode },
                    });

                    if (existedData) {
                        const update = await transactionManager
                            .getRepository(PayrollComponents)
                            .update({ id: existedData.id }, {
                                messAmount: data.MessAmount,
                                othersAmount: data.OthersAmount
                            });

                        if (!update.affected) {
                            flag.add(false);
                            await transactionManager.releaseTransaction();
                            return new CommonResponse(
                                false,
                                0,
                                'Failed to update the existing record'
                            );
                        } else {
                            const logs = [];

                            if (data.MessAmount != null) {
                                const messLog = new PayrollComponentsLogs();
                                messLog.employeeId = existedData.employeeId;
                                messLog.employeeName = existedData.employeeName;
                                messLog.employeeCode = existedData.employeeCode;
                                messLog.employeeType = existedData.employeeType;
                                messLog.employeeCategory = existedData.employeeCategory;
                                messLog.designation = existedData.designation;
                                messLog.department = existedData.department
                                messLog.transactionName = 'messAmount';
                                messLog.type = 'D'; // Deduction
                                messLog.amount = data.MessAmount;
                                logs.push(messLog);
                            }

                            if (data.OthersAmount != null) {
                                const othersLog = new PayrollComponentsLogs();
                                othersLog.employeeId = existedData.employeeId;
                                othersLog.employeeName = existedData.employeeName;
                                othersLog.employeeCode = existedData.employeeCode;
                                othersLog.employeeType = existedData.employeeType;
                                othersLog.employeeCategory = existedData.employeeCategory;
                                othersLog.designation = existedData.designation;
                                othersLog.department = existedData.department
                                othersLog.transactionName = '0thersAmount';
                                othersLog.type = 'D'; // Deduction
                                othersLog.amount = data.OthersAmount;
                                logs.push(othersLog);
                            }

                            const logsSaved = await transactionManager
                                .getRepository(PayrollComponentsLogs)
                                .save(logs);

                            if (logsSaved) {
                                flag.add(true);
                            } else {
                                flag.add(false);
                                await transactionManager.releaseTransaction();
                                break;
                            }
                        }
                    } else {
                        // Track missing employee codes
                        missingEmployeeCodes.push(data.EmployeeCode);
                    }
                }
            }

            if (missingEmployeeCodes.length > 0) {
                await transactionManager.releaseTransaction();
                return new CommonResponse(false, 1116, `Please Fill Basic Details In Employee Payables Screen For this Employee: ${missingEmployeeCodes.join(', ')}`);
            }

            if (!flag.has(false)) {
                await transactionManager.completeTransaction();
                return new CommonResponse(true, 1, 'Data saved successfully');
            } else {
                await transactionManager.releaseTransaction();
                return new CommonResponse(false, 0, 'Something went wrong');
            }
        } catch (err) {
            await transactionManager.releaseTransaction();
            return new CommonResponse(false, 0, `Error: ${err.message}`);
        }
    }




    async getDeductionsData(): Promise<CommonResponse> {
        try {
            let dataQuery = `SELECT employee_id as employeeId,mess_d as messAmount, others_d as othersAmount,
        employee_name as employeeName, employee_code as employeeCode ,des.designation, dep.dept_name as departmentName,  employee_type as employeeType
                FROM payroll_components pc
                            LEFT JOIN ${appSettings.hrms_db}.designation des 
                            ON des.designation_id = pc.designation
                            LEFT JOIN ${appSettings.masters_db}.departments dep ON dep.dept_id = pc.department`

            const rawData = await this.payrollProcessRepo.query(dataQuery);
            return new CommonResponse(true, 233, 'data retrived successfully', rawData)
        } catch (error) {
            throw error
        }
    }


    async generatePayRoll(req: PayRollRequest): Promise<CommonResponse> {
        const transactionManager = new GenericTransactionManager();
        try {
            const monthReq = req.month;
            const yearPart = Math.floor(monthReq / 100);
            const monthPart = monthReq % 100;

            let payrollSaveFlag = new Set<boolean>()
            await transactionManager.startTransaction()
            const manager = getManager();
            const freezePayrollCheckQry = `select * from ` + appSettings.hrms_db + `.payroll_log where payroll_month = '${req.month}' and freeze_status = 1 `
            const freezrPayrollCheck = await manager.query(freezePayrollCheckQry)
            if (freezrPayrollCheck.length > 0) {
                const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                const month = monthNames[Number(String(req.month).substring(4, 6)) - 1]
                await transactionManager.releaseTransaction()
                return new CommonResponse(false, 0, `${month} month payroll is already processed and freezed`)
            } else {
                //check payroll exist or not 
                const existedPayrollCheck = `select count(*) as count from ` + appSettings.hrms_db + `.payroll_log where payroll_month = '${req.month}' `;
                const payRollCheckCount = await manager.query(existedPayrollCheck)
                if (Number(payRollCheckCount[0].count) > 0) {
                    const deletePayroll = await transactionManager.getRepository(PayrollLogs).delete({ payrollMonth: String(req.month) })
                    if (!(deletePayroll.affected)) {
                        await transactionManager.releaseTransaction()
                        return new CommonResponse(false, 0, 'something went wrong in deletion')
                    }
                }
                const payrollComponents = await transactionManager.getRepository(PayrollComponents).find();
                for (const component of payrollComponents) {
                    console.log(component, 'component')
                    const payrollLog = new PayrollLogs();
                    payrollLog.employeeId = component.employeeId;
                    payrollLog.employeeName = component.employeeName;
                    payrollLog.employeeCode = component.employeeCode;
                    payrollLog.department = component.designation;
                    payrollLog.designationId = component.designation
                    payrollLog.employeeType = component.employeeType;
                    payrollLog.payrollMonth = String(req.month);
                    if (payrollLog.employeeType == 'Salaried Form') {
                        payrollLog.basic = component.basic;
                        payrollLog.hraAmount = component.hraAmount;
                        payrollLog.eduAmount = component.eduAmount;
                        payrollLog.medicalAmount = component.medicalAmount;
                        payrollLog.splAmount = component.splAmount;
                        payrollLog.conveyanceAmount = component.conveyanceAmount;
                        payrollLog.petrolAmount = component.petrolAmount;
                        payrollLog.shoeAmount = component.shoeAmount;
                        payrollLog.washingAmount = component.washingAmount;
                        payrollLog.uniformAmount = component.uniformAmount;
                        payrollLog.helperAmount = component.helperAmount;
                        payrollLog.productionAmount = component.productionAmount;
                        payrollLog.taAmount = component.taAmount;
                        payrollLog.bonusAmount = component.bonusAmount;

                        const empRecords = await this.attendanceRepo.getMonthRecordsForEmp(yearPart, component.employeeId, monthPart);
                        let presentCount = 0;
                        let outDoorCount = 0;
                        let absentCount = 0;
                        let compOffCount = 0;
                        let workFromHomeCount = 0;
                        let leaveCount = 0;
                        let weekOffCount = 0;
                        let publicHolidayCount = 0;
                        let notOutPunchCount = 0;
                        let totalDaysCount = 0;
                        let totalPresentDays = 0;
                        let payableDays = 0;
                        let monthDays = 0
                        const daysInMonth = {
                            1: 31,
                            2: new Date(yearPart, 1, 29).getMonth() === 1 ? 29 : 28,
                            3: 31,
                            4: 30,
                            5: 31,
                            6: 30,
                            7: 31,
                            8: 31,
                            9: 30,
                            10: 31,
                            11: 30,
                            12: 31
                        };
                        monthDays = daysInMonth[monthPart];
                        const startDate: any = moment(new Date(yearPart, monthPart - 2, 26), "Asia/Calcutta").format('YYYY-MM-DD'); //.toISOString().split('T')[0];
                        const endDate: any = moment(new Date(yearPart, monthPart - 1, 25), "Asia/Calcutta").format('YYYY-MM-DD'); // .toISOString().split('T')[0];

                        const daysCount = (endDate - startDate) / (1000 * 60 * 60 * 24) + 1;

                        for (const empRecord of empRecords) {
                            const status = empRecord.present_status;
                            const count = Number(empRecord.count);
                            if (['P', 'P/CO', 'P/L', 'P/OD', 'P/2'].includes(status)) {
                                if (status === 'P') {
                                    presentCount += count;
                                } else if (['P/CO', 'P/L'].includes(status)) {
                                    presentCount += count * 0.5;
                                } else if (status === 'P/2') {
                                    presentCount += count * 0.5;
                                    absentCount += count * 0.5;
                                } else if (status === 'P/OD') {
                                    presentCount += count * 0.5;
                                    absentCount += count * 0.5;
                                }

                            } else if (['W', 'WP', 'WP/2', 'WNIP', 'WNOP'].includes(status)) {
                                weekOffCount += count;
                            } else if (['PH', 'PHP', 'PHNOP', 'PHNIP', 'PHP/2'].includes(status)) {
                                publicHolidayCount += count;
                            } else if (['OD'].includes(status)) {
                                outDoorCount += count;
                            } else if (['L', 'P/L', 'CO/L', 'L/2'].includes(status)) {
                                leaveCount += (status === 'P/L' || status === 'CO/L' || status === 'L/2') ? count * 0.5 : count;
                            } else if (['CO', 'P/CO', 'CO/2', 'CO/L'].includes(status)) {
                                compOffCount += (status === 'P/CO' || status === 'CO/2' || status === 'CO/L') ? count * 0.5 : count;
                            } else if (['NOP', 'NIP'].includes(status)) {
                                notOutPunchCount += count;
                            } else if (status === 'A') {
                                absentCount += count;
                            }
                        }
                        totalDaysCount = presentCount + outDoorCount + leaveCount + weekOffCount + publicHolidayCount + compOffCount

                        if (totalDaysCount === daysCount) {
                            payableDays = monthDays;
                        } else {
                            payableDays = monthDays - (daysCount - totalDaysCount)
                        }

                        payrollLog.factoryWorkingDays = Number(daysCount);
                        payrollLog.attendance = Number(payableDays);
                        console.log(payrollLog.attendance, 'payrollLog.attendance')
                        if (daysCount == 0) {
                            payrollLog.calBasic = 0;
                            payrollLog.calHra = 0;
                            payrollLog.calEdu = 0;
                            payrollLog.calMedical = 0;
                            payrollLog.calSpl = 0;
                            payrollLog.calConveyance = 0;
                            payrollLog.calPetrol = 0;
                            payrollLog.calShoe = 0;
                            payrollLog.calWashing = 0;
                            payrollLog.calUniform = 0;
                            payrollLog.calHelper = 0;
                            payrollLog.totalEarnings = 0;
                        } else {
                            payrollLog.calBasic = Math.round(Number(Number(component.basic / monthDays) * payableDays));
                            payrollLog.calHra = Math.round(Number((component.hraAmount / monthDays) * payableDays));
                            payrollLog.calEdu = Math.round(Number((component.eduAmount / monthDays) * payableDays));
                            payrollLog.calMedical = Math.round(Number((component.medicalAmount / monthDays) * payableDays));
                            payrollLog.calSpl = Math.round(Number((component.splAmount / monthDays) * payableDays));
                            payrollLog.calConveyance = Math.round(Number((component.conveyanceAmount / monthDays) * payableDays));
                            payrollLog.calPetrol = Math.round(Number((component.petrolAmount / monthDays) * payableDays));
                            payrollLog.calShoe = Math.round(Number((component.shoeAmount / monthDays) * payableDays));
                            payrollLog.calWashing = Math.round(Number((component.washingAmount / monthDays) * payableDays));
                            payrollLog.calUniform = Math.round(Number((component.uniformAmount / monthDays) * payableDays));
                            payrollLog.calHelper = Math.round(Number((component.helperAmount / monthDays) * payableDays));
                            payrollLog.totalEarnings = Math.round(Number(payrollLog.calBasic + payrollLog.calHra + payrollLog.calEdu + payrollLog.calMedical + payrollLog.calConveyance + payrollLog.calSpl + payrollLog.calPetrol + payrollLog.calShoe + payrollLog.calWashing + payrollLog.calUniform + payrollLog.calHelper));
                        }

                        if (payrollLog.calBasic < 15000) {
                            payrollLog.epfAmount = Math.round(Number(payrollLog.calBasic * 0.12));
                        } else {
                            payrollLog.epfAmount = 1800;
                        }

                        if (payrollLog.totalEarnings < 14999) {
                            payrollLog.professionalTax = 0
                        } else if (payrollLog.totalEarnings > 15000 && payrollLog.totalEarnings < 19999) {
                            payrollLog.professionalTax = 150
                        } else {
                            payrollLog.professionalTax = 200
                        }

                        let actualEarningsForEsic = (Number(component.basic) || 0) + (Number(component.hraAmount) || 0) + (Number(component.medicalAmount) || 0) + (Number(component.eduAmount) || 0) + (Number(component.splAmount) || 0);

                        let calEarningsForEsic = (Number(payrollLog.calBasic) || 0) + (Number(payrollLog.calHra) || 0) + (Number(payrollLog.calMedical) || 0) + (Number(payrollLog.calEdu) || 0) + (Number(payrollLog.calSpl) || 0);
                        if (actualEarningsForEsic >= 21000) {
                            payrollLog.esicAmount = 0;
                        } else {
                            if (calEarningsForEsic >= 21000) {
                                payrollLog.esicAmount = 0;
                            } else {
                                payrollLog.esicAmount = Math.round(Number(calEarningsForEsic * 0.75 / 100));
                            }
                        }
                        payrollLog.messAmount = Math.round(Number(component.messAmount)) || 0;
                        payrollLog.othersAmount = Math.round(Number(component.othersAmount)) || 0;
                        payrollLog.epfAmount = Math.round(Number(payrollLog.epfAmount)) || 0;
                        payrollLog.tds = Math.round(Number(payrollLog.tds)) || 0;
                        payrollLog.esicAmount = Math.round(Number(payrollLog.esicAmount)) || 0;
                        payrollLog.professionalTax = Math.round(Number(payrollLog.professionalTax)) || 0;
                        payrollLog.totalDeductions = Math.round(Number(payrollLog.epfAmount + payrollLog.esicAmount + payrollLog.messAmount + payrollLog.othersAmount + payrollLog.tds + payrollLog.professionalTax));
                        payrollLog.netSalary = Math.round(Number(payrollLog.totalEarnings - payrollLog.totalDeductions));
                        payrollLog.isActive = true;
                        payrollLog.createdAt = new Date();
                    } else if (component.employeeType === 'Labour Form' && component.employeeCategory === 'NMR') {
                        payrollLog.employeeId = component.employeeId;
                        payrollLog.employeeName = component.employeeName;
                        payrollLog.employeeCode = component.employeeCode;
                        payrollLog.employeeType = component.employeeType;
                        payrollLog.employeeCategory = component.employeeCategory;
                        payrollLog.payrollMonth = String(req.month);
                        payrollLog.basic = component.basic;
                        payrollLog.hraAmount = component.hraAmount;
                        payrollLog.eduAmount = component.eduAmount;
                        payrollLog.medicalAmount = component.medicalAmount;
                        payrollLog.splAmount = component.splAmount;
                        payrollLog.conveyanceAmount = component.conveyanceAmount;
                        payrollLog.petrolAmount = component.petrolAmount;
                        payrollLog.shoeAmount = component.shoeAmount;
                        payrollLog.washingAmount = component.washingAmount;
                        payrollLog.uniformAmount = component.uniformAmount;
                        payrollLog.helperAmount = component.helperAmount;
                        payrollLog.productionAmount = component.productionAmount;
                        payrollLog.taAmount = component.taAmount;
                        payrollLog.bonusAmount = component.bonusAmount;

                        const empRecords = await this.attendanceRepo.getNmrMonthRecordsForEmp(yearPart, component.employeeId, monthPart);

                        let presentCount = 0;
                        let outDoorCount = 0;
                        let absentCount = 0;
                        let weekOffCount = 0;
                        let publicHolidayCount = 0;
                        let notOutPunchCount = 0;
                        let totalDaysCount = 0;
                        let payableDays = 0;
                        let monthDays = 0
                        const daysInMonth = {
                            1: 31,
                            2: new Date(yearPart, 1, 29).getMonth() === 1 ? 29 : 28,
                            3: 31,
                            4: 30,
                            5: 31,
                            6: 30,
                            7: 31,
                            8: 31,
                            9: 30,
                            10: 31,
                            11: 30,
                            12: 31
                        };

                        monthDays = daysInMonth[monthPart];
                        const startDate: any = moment(new Date(yearPart, monthPart - 2, 26), "Asia/Calcutta").format('YYYY-MM-DD'); //.toISOString().split('T')[0];
                        const endDate: any = moment(new Date(yearPart, monthPart - 1, 25), "Asia/Calcutta").format('YYYY-MM-DD'); // .toISOString().split('T')[0];

                        const daysCount = (endDate - startDate) / (1000 * 60 * 60 * 24) + 1;


                        for (const empRecord of empRecords) {
                            const status = empRecord.present_status;
                            const count = Number(empRecord.count);
                            console.log(status, ':', count)
                            if (['P', 'P/CO', 'P/L', 'P/OD', 'P/2'].includes(status)) {
                                if (status === 'P') {
                                    presentCount += count;
                                } else if (['P/CO', 'P/L'].includes(status)) {
                                    presentCount += count * 0.5;
                                } else if (status === 'P/2') {
                                    presentCount += count * 0.5;
                                    absentCount += count * 0.5
                                } else if (status === 'P/OD') {
                                    presentCount += count * 0.5;
                                    outDoorCount += count * 0.5
                                }

                            } else if (['W', 'WP', 'WP/2', 'WNIP', 'WNOP'].includes(status)) {
                                weekOffCount += count;
                            } else if (['PH', 'PHP', 'PHNOP', 'PHNIP', 'PHP/2'].includes(status)) {
                                publicHolidayCount += count;
                            } else if (['OD'].includes(status)) {
                                outDoorCount += count;
                            } else if (['NOP', 'NIP'].includes(status)) {
                                notOutPunchCount += count;
                            } else if (status === 'A') {
                                absentCount += count;
                            }
                        }
                        totalDaysCount = presentCount + outDoorCount + weekOffCount + publicHolidayCount + notOutPunchCount
                        if (totalDaysCount === daysCount) {
                            payableDays = monthDays;
                        } else {
                            payableDays = monthDays - (daysCount - totalDaysCount)
                        }
                        payrollLog.factoryWorkingDays = monthDays;
                        payrollLog.attendance = payableDays;
                        const reqMonthStr = req.month.toString();
                        const year = parseInt(reqMonthStr.substring(0, 4), 10);
                        const month = parseInt(reqMonthStr.substring(4, 6), 10);
                        const NMR = await this.attendanceRepo.getNMRIncentiveHrsByMonthOfEmp(year, month, component.employeeId);
                        function convertToDecimalHours(time: string): number {
                            const [hours, minutes] = time.split(':').map(Number);
                            return hours + (minutes / 60);
                        }

                        function convertDecimalToHoursMinutes(decimalHours: number): string {
                            const hours = Math.floor(decimalHours);
                            const minutes = Math.round((decimalHours - hours) * 60);
                            return `${String(hours).padStart(2, '0')}.${String(minutes).padStart(2, '0')}`;
                        }
                        let totalAllIncentiveHrs = 0;
                        for (const nmrRecords of NMR) {
                            const hours = convertToDecimalHours(nmrRecords.totalHours || '0:00');
                            let incentiveHours = 0;
                            if (nmrRecords.presentStatus === 'P' && hours > 8) {
                                incentiveHours = hours - 8;
                            } else if (nmrRecords.presentStatus === 'WP' || nmrRecords.presentStatus === 'PHP') {
                                incentiveHours = hours;
                            } else {
                                incentiveHours = 0;
                            }
                            totalAllIncentiveHrs += incentiveHours;
                        }
                        payrollLog.totalIncentiveHr = Math.round(Number(convertDecimalToHoursMinutes(totalAllIncentiveHrs)))
                        if (daysCount == 0) {
                            payrollLog.calBasic = 0
                            payrollLog.calHra = 0
                            payrollLog.calEdu = 0
                            payrollLog.calMedical = 0
                            payrollLog.calConveyance = 0
                            payrollLog.calPetrol = 0
                            payrollLog.calShoe = 0
                            payrollLog.calWashing = 0
                            payrollLog.calUniform = 0
                            payrollLog.calHelper = 0
                            payrollLog.totalEarnings = Number(payrollLog.calBasic + payrollLog.calHra + payrollLog.calEdu + payrollLog.calMedical + payrollLog.calConveyance + payrollLog.calPetrol + payrollLog.calShoe + payrollLog.calWashing + payrollLog.calUniform + payrollLog.calHelper);
                        } else {
                            payrollLog.calBasic = Math.round(Number((component.basic / monthDays) * payableDays));
                            payrollLog.calHra = Math.round(Number((component.hraAmount / monthDays) * payableDays));
                            payrollLog.calEdu = Math.round(Number((component.eduAmount / monthDays) * payableDays));
                            payrollLog.calMedical = Math.round(Number((component.medicalAmount / monthDays) * payableDays));
                            payrollLog.calConveyance = Math.round(Number((component.conveyanceAmount / monthDays) * payableDays));
                            payrollLog.calPetrol = Math.round(Number((component.petrolAmount / monthDays) * payableDays));
                            payrollLog.calShoe = Math.round(Number((component.shoeAmount / monthDays) * payableDays));
                            payrollLog.calWashing = Math.round(Number((component.washingAmount / monthDays) * payableDays));
                            payrollLog.calUniform = Math.round(Number((component.uniformAmount / monthDays) * payableDays));
                            payrollLog.calHelper = Math.round(Number((component.helperAmount / monthDays) * payableDays));
                            payrollLog.otherEarnings = Math.round(Number(component.earnings))
                            payrollLog.incentiveAmountPerHr = Math.round((Number(component.basic) / monthDays) / 8);
                            console.log(payrollLog.incentiveAmountPerHr, "incentiveAmountPerHr")
                            payrollLog.incentiveAmount = Math.round(Number(payrollLog.incentiveAmountPerHr) * Number(payrollLog.totalIncentiveHr));
                            console.log(payrollLog.incentiveAmount, "payrollLog.incentiveAmount")
                            payrollLog.calGross = Math.round(Number(payrollLog.calBasic + payrollLog.calShoe + payrollLog.calWashing + payrollLog.calUniform + payrollLog.otherEarnings))
                            payrollLog.totalEarnings = Math.round(Number(payrollLog.calBasic + payrollLog.calHra + payrollLog.calEdu + payrollLog.calMedical + payrollLog.calConveyance + payrollLog.calPetrol + payrollLog.calShoe + payrollLog.calWashing + payrollLog.calUniform + payrollLog.calHelper + payrollLog.incentiveAmount + payrollLog.otherEarnings));

                        }
                        if (payrollLog.calBasic < 15000) {
                            payrollLog.epfAmount = Math.round(Number(payrollLog.calBasic * 0.12));
                        } else {
                            payrollLog.epfAmount = 1800;
                        };
                        let actualEarningsForEsic = (Number(component.basic) || 0) + (Number(component.uniformAmount) || 0);
                        let calEarningsForEsic = (Number(payrollLog.calBasic) || 0) + (Number(payrollLog.calUniform) || 0);

                        if (actualEarningsForEsic >= 21000) {
                            payrollLog.esicAmount = 0;
                        } else {
                            if (calEarningsForEsic >= 21000) {
                                payrollLog.esicAmount = 0;
                            } else {
                                payrollLog.esicAmount = Math.round(Number(calEarningsForEsic * 0.75 / 100));
                            }
                        }
                        payrollLog.messAmount = Math.round(Number(component.messAmount));
                        payrollLog.othersAmount = Math.round(Number(component.othersAmount));
                        payrollLog.totalDeductions = Math.round(Number(payrollLog.epfAmount + payrollLog.esicAmount + payrollLog.messAmount + payrollLog.othersAmount))
                        payrollLog.netSalary = Number(payrollLog.totalEarnings - payrollLog.totalDeductions)
                        payrollLog.isActive = true;
                        payrollLog.createdAt = new Date();
                    } else if (component.employeeType === 'Labour Form' && component.employeeCategory === 'In-House') {
                        payrollLog.employeeId = component.employeeId;
                        payrollLog.employeeName = component.employeeName;
                        payrollLog.employeeCode = component.employeeCode;
                        payrollLog.employeeType = component.employeeType;
                        payrollLog.employeeCategory = component.employeeCategory;
                        payrollLog.payrollMonth = String(req.month);
                        payrollLog.basic = Number(component.basic);
                        payrollLog.medicalAmount = Number(component.medicalAmount);
                        payrollLog.uniformAmount = Number(component.uniformAmount);
                        payrollLog.productionAmount = Number(component.productionAmount);
                        payrollLog.taAmount = Number(component.taAmount);
                        payrollLog.bonusAmount = Number(component.bonusAmount);
                        payrollLog.gross = Math.round(Number(component.basic || 0) + Number(component.medicalAmount || 0) + Number(component.uniformAmount || 0 ) + Number(component.productionAmount || 0) + Number(component.taAmount || 0) + Number(component.bonusAmount ||0))

                        console.log(yearPart, "yearPart")
                        console.log(monthPart, "monthPart")
                        const empRecords = await this.attendanceRepo.getWorkerMonthRecordsForEmp(yearPart, component.employeeId, monthPart);
                        console.log(component.employeeId, "wempID")
                        let presentCount = 0;
                        let weekOffCount = 0;
                        let wpCount = 0;
                        let publicHolidayCount = 0;
                        let phpCount = 0;
                        let notOutPunchCount = 0;
                        let presentDays = 0;
                        let absentCount = 0;
                        let monthDays = 0
                        const daysInMonth = {
                            1: 31,
                            2: new Date(yearPart, 1, 29).getMonth() === 1 ? 29 : 28,
                            3: 31,
                            4: 30,
                            5: 31,
                            6: 30,
                            7: 31,
                            8: 31,
                            9: 30,
                            10: 31,
                            11: 30,
                            12: 31
                        };
                        monthDays = daysInMonth[monthPart];

                        console.log(monthDays, "wmonthDays")
                        for (const empRecord of empRecords) {
                            const status = empRecord.present_status;
                            const count = Number(empRecord.count);
                            console.log(status, ':', count)
                            if (['P', 'P/2'].includes(status)) {
                                if (status === 'P') {
                                    presentCount += count;
                                } else if (['P/2'].includes(status)) {
                                    presentCount += count * 0.5;
                                    absentCount += count * 0.5
                                }
                            } else if (['WO'].includes(status)) {
                                weekOffCount += count;
                            } else if (['WP', 'WP/2', 'WNOP', 'WNIP'].includes(status)) {
                                wpCount += count;
                            } else if (['PH'].includes(status)) {
                                publicHolidayCount += count;
                            } else if (['PHP'].includes(status)) {
                                phpCount += count;
                            } else if (['NOP', 'NIP'].includes(status)) {
                                notOutPunchCount += count;
                            } else if (status === 'A') {
                                absentCount += count;
                            }
                        }
                        presentDays = presentCount + wpCount + phpCount + weekOffCount + publicHolidayCount
                        console.log(presentDays, "wpresentDays")
                        payrollLog.factoryWorkingDays = monthDays;
                        payrollLog.attendance = presentDays;
                        const reqMonthStr = req.month.toString();
                        const year = parseInt(reqMonthStr.substring(0, 4), 10);
                        const month = parseInt(reqMonthStr.substring(4, 6), 10);
                        const inHouseRecord = await this.attendanceRepo.getWorkersIncentiveHrsByMonthOfEmp(year, month, component.employeeId);

                        function convertToDecimalHours(time: string): number {
                            const [hours, minutes] = time.split(':').map(Number);
                            return hours + (minutes / 60);
                        }

                        function convertDecimalToHoursMinutes(decimalHours: number): string {
                            const hours = Math.floor(decimalHours);
                            const minutes = Math.round((decimalHours - hours) * 60);
                            return `${String(hours).padStart(2, '0')}.${String(minutes).padStart(2, '0')}`;
                        }
                        let totalAllIncentiveHrs = 0;
                        for (const record of inHouseRecord) {
                            const hours = convertToDecimalHours(record.totalHours || '0:00');
                            let incentiveHours = 0;
                            if (record.presentStatus === 'P' && hours > 8) {
                                incentiveHours = hours - 8;
                            } else if (record.presentStatus === 'WP' || record.presentStatus === 'PHP') {
                                incentiveHours = hours;
                            } else {
                                incentiveHours = 0;
                            }
                            totalAllIncentiveHrs += incentiveHours;
                        }
                        console.log(totalAllIncentiveHrs, 'TotalInsWS')
                        if (presentDays == 0) {
                            payrollLog.calBasic = 0
                            payrollLog.calHra = 0
                            payrollLog.calEdu = 0
                            payrollLog.calMedical = 0
                            payrollLog.calConveyance = 0
                            payrollLog.calPetrol = 0
                            payrollLog.calShoe = 0
                            payrollLog.calWashing = 0
                            payrollLog.calUniform = 0
                            payrollLog.calHelper = 0
                            payrollLog.totalEarnings = Math.round(Number(payrollLog.calBasic + payrollLog.calHra + payrollLog.calEdu + payrollLog.calMedical + payrollLog.calConveyance + payrollLog.calPetrol + payrollLog.calShoe + payrollLog.calWashing + payrollLog.calUniform + payrollLog.calHelper));
                        } else {
                            payrollLog.calBasic = Math.round(Number((component.basic / monthDays) * presentDays));
                            if(presentDays >= 7 ){
                            payrollLog.calMedical = Math.round(Number(component.medicalAmount));
                            }else{
                            payrollLog.calMedical = 0 ;
                            }
                            payrollLog.calUniform = Math.round(Number((component.uniformAmount / monthDays) * presentDays));
                            payrollLog.calProduction = Math.round(Number((component.productionAmount / monthDays) * presentDays));
                            payrollLog.calTa = Math.round(Number((component.taAmount / monthDays) * presentDays));
                            payrollLog.calBonus = Math.round(Number((component.bonusAmount / monthDays) * presentDays));
                            payrollLog.calGross = Math.round(Number(payrollLog.calBasic + payrollLog.calBonus));
                            
                            payrollLog.totalIncentiveHr = Math.round(Number(convertDecimalToHoursMinutes(totalAllIncentiveHrs)))
                            console.log(payrollLog.totalIncentiveHr, "payrollLog.totalIncentiveHrCal")
                            payrollLog.incentiveAmountPerHr = Math.round((Number(component.basic) / monthDays) / 8);
                            console.log(payrollLog.incentiveAmountPerHr, "incentiveAmountPerHr")
                            payrollLog.incentiveAmount = Math.round(Number(payrollLog.incentiveAmountPerHr) * Number(payrollLog.totalIncentiveHr));
                            payrollLog.calGross = Math.round(Number(payrollLog.calBasic + payrollLog.calMedical + payrollLog.calUniform + payrollLog.calProduction + payrollLog.calTa + payrollLog.calBonus));
                            payrollLog.totalEarnings = Math.round(Number(payrollLog.calBasic + payrollLog.calMedical + payrollLog.calUniform + payrollLog.calProduction + payrollLog.calTa + payrollLog.calBonus + payrollLog.incentiveAmount));
                            payrollLog.messAmount = Math.round(Number(component.messAmount));
                            payrollLog.othersAmount = Math.round(Number(component.othersAmount));
                            let sumDeduction = Math.round(Number(payrollLog.messAmount + payrollLog.othersAmount ))
                            if(Number(payrollLog.totalEarnings) > sumDeduction){
                                payrollLog.totalDeductions = Math.round(Number(payrollLog.epfAmount || 0)+ Number(payrollLog.esicAmount || 0) + Number(payrollLog.messAmount || 0) + Number(payrollLog.othersAmount ||0));
                            }else{
                                payrollLog.totalDeductions =  payrollLog.totalEarnings
                            }
                            payrollLog.netSalary = Math.round(Number(payrollLog.totalEarnings - payrollLog.totalDeductions));
                        }
                        payrollLog.isActive = true;
                        payrollLog.createdAt = new Date();
                    }
                    console.log(payrollLog, "payrollLogpayrollLog")
                    const savedLog = await transactionManager.getRepository(PayrollLogs).save(payrollLog);
                    console.log('Saved Log Result:', savedLog); // Debugging line
                    payrollSaveFlag.add(!savedLog);
                }
                await transactionManager.completeTransaction()
                return new CommonResponse(true, payrollSaveFlag.size, 'Payroll generated successfully');
            }
        } catch (err) {
            // console.log(err.sqlMessage,'---------------')
            await transactionManager.releaseTransaction()
            if (err?.sqlMessage) {
                return new CommonResponse(false, 0, err.sqlMessage)
            } else {
                return new CommonResponse(false, 0, err)
            }
        }

    }
    async getAllPayrollLogs(req: PayRollMonthDto): Promise<CommonResponse> {
        try {
            const manager = getManager()
            let query = `SELECT p.employee_id , p.employee_name , p.employee_code , p.employee_type , p.employee_category , p.department ,d.dept_name , p.designation as designationId , de.designation, p.payroll_month , p.factory_working_days ,p.attendance, p.basic , p.hra_amount , p.edu_amount , p.medical_amount , p.spl_amount , p.conveyance_amount , p.petrol_Amount , p.shoe_amount , p.washing_amount , p.uniform_amount , p.helper_amount ,p. production_amount , p.ta_amount , p.bonus_amount , p.gross ,p.incentive_hrs , p.cal_basic , p.cal_hra , p.cal_edu ,p.cal_medical , p.cal_spl , p.cal_conveyance , p.cal_petrol , p.cal_shoe , p.cal_washing , p.cal_uniform , p.cal_helper , p.cal_production , p.cal_ta ,p.cal_bonus , p.cal_gross , p.incentive_amount_per_hr , p.total_incentive_hrs , p.incentive_amount ,p.total_earnings , p.epf_amount , p.esic_amount ,p.mess_d , p.others_d , p.tds , p.Professional_tax , p.total_deductions , p.net_salary , p.unit_id, p.freeze_status FROM ` + appSettings.hrms_db + `.payroll_log p
            LEFT JOIN `+ appSettings.masters_db + `.departments d ON d.dept_id = p.department
            LEFT JOIN `+ appSettings.hrms_db + `.designation de ON p.designation = de.designation_id
            WHERE p.id > 0`
            if (req?.month) {
                query = query + ' and p.payroll_month = "' + req?.month + '"';
            }
            if (req?.unitId && req?.unitId != 5) {
                query = query + ' and p.unit_id = ' + req?.unitId;
            }
            if (req?.department) {
                query = query + ' and p.department = ' + req?.department;
            }
            if (req?.empType) {
                query = query + ' and p.employee_type = "' + req?.empType + '"';
            }
            if (req?.employeeId) {
                query = query + ' and p.employee_id = ' + req?.employeeId;
            };
            const data = await manager.query(query)
            return new CommonResponse(true, 111, "data retrieved successfully", data)
        } catch (err) {
            throw err
        }
    }



    async getPayrollLogByEmployeeId(req: EmployeeIdReq): Promise<CommonResponse> {
        try {
            const data = await this.payslipRepo.getByEmployeeId(req);
            const payslipMap = new Map<number, NormalPayslipReq>();

            if (data && data.length > 0) {
                for (const rec of data) {
                    console.log(rec, 'recccccccccc')
                    if (!payslipMap.has(rec.employeeId)) {
                        payslipMap.set(rec.employeeId, new NormalPayslipReq(rec.id, rec.employeeId, rec.employeeName, rec.employeeCode, rec.employeeType, rec.employeeCategory, rec.designation, rec.department, rec.payrollMonth, rec.factoryWorkingDays, rec.attendance, rec.basic, rec.hraAmount, rec.eduAmount, rec.medicalAmount, rec.splAmount, rec.conveyanceAmount, rec.petrolAmount, rec.shoeAmount, rec.washingAmount, rec.uniformAmount, rec.helperAmount, rec.productionAmount, rec.taAmount, rec.bonusAmount, rec.gross, rec.incentiveHrs, rec.calBasic, rec.calHra, rec.calEdu, rec.calMedical, rec.calSpl, rec.calConveyance, rec.calPetrol, rec.calShoe, rec.calWashing, rec.calUniform, rec.calHelper, rec.calProduction, rec.calTa, rec.calBonus, rec.calGross, rec.incentiveAmountPerHr, rec.totalIncentiveHr, rec.incentiveAmount, rec.totalEarnings, rec.epfAmount, rec.esicAmount, rec.messAmount, rec.othersAmount, rec.tds, rec.professionalTax, rec.totalDeductions, rec.netSalary, rec.bank, rec.bankAcNo, rec.ifsc, rec.uan, rec.doj, rec.pan, rec.esi, rec.emailId
                        ));
                    }
                }

                const payslipModel: NormalPayslipReq[] = Array.from(payslipMap.values());
                return new CommonResponse(true, 1, 'Data retrieved', payslipModel);
            } else {
                return new CommonResponse(false, 0, 'No data found');
            }
        } catch (err) {
            console.error('Error retrieving payroll log:', err);
            return new CommonResponse(false, 0, 'An error occurred while retrieving data');
        }
    }


    async getEmployeeDataAgainstYearMonth(req: EmployeeIdReq): Promise<CommonResponse> {
        try {
            const data = await this.payslipRepo.getEmployeeInfoAgainstYearMonth(req)
            if (data) {
                let index = 0
                for (const rec of data) {
                    index += 1
                    rec.index = index
                }
                return new CommonResponse(true, 1, 'Data retrieved', data)
            } else {
                return new CommonResponse(false, 0, 'No data found')
            }
        } catch (err) {
            throw err
        }
    }


    async getAllEmployeeEmployeeNamePayrollLogs(): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `SELECT p.employee_name, p.department, d.dept_name
            FROM `+ appSettings.hrms_db + `.payroll_log p
            JOIN `+ appSettings.masters_db + `.departments d ON p.department = d.dept_id
            WHERE p.employee_type = "Salaried Form" ;`;
            const data = await manager.query(query)
            return new CommonResponse(true, 111, "data retrieved successfully", data)
        } catch (err) {
            throw err
        }

    }

    async getAllNMREmployeeNamePayrollLogs(): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `SELECT p.employee_name, p.department, d.dept_name
            FROM `+ appSettings.hrms_db + `.payroll_log p
            JOIN `+ appSettings.masters_db + `.departments d ON p.department = d.dept_id
            WHERE p.employee_type = "Labour Form" AND p.employee_category = "NMR" `;
            const data = await manager.query(query)
            return new CommonResponse(true, 111, "data retrieved successfully", data)
        } catch (err) {
            throw err
        }

    }

    async getAllInHouseEmployeeNamePayrollLogs(): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `SELECT p.employee_name, p.department, d.dept_name, p.designation, s.designation AS designation_name
            FROM `+ appSettings.hrms_db + `.payroll_log p
            JOIN `+ appSettings.hrms_db + `.designation s ON p.designation = s.designation_id
            JOIN `+ appSettings.masters_db + `.departments d ON p.department = d.dept_id
            WHERE p.employee_type = "Labour Form" AND p.employee_category = "In-House";`;
            const data = await manager.query(query)
            return new CommonResponse(true, 111, "data retrieved successfully", data)
        } catch (err) {
            throw err
        }

    }


    async getPayrollAllData(req?: PayRollRequest): Promise<CommonResponse> {
        try {
            const data = await this.payrollLogsRepo.getPayrollData(req)
            if (data) {
                return new CommonResponse(true, 111, 'Data Retrived Sucessfully', data)
            } else {
                return new CommonResponse(false, 0, 'No Data Found..', data)

            }
        }
        catch (err) {
            throw err
        }

    }

    async updateFreezeStatus(req: PayRollMonthDto): Promise<CommonResponse> {
        console.log(req, 'req')
        try {
            const manager = getManager()
            let dataQuery = `UPDATE ` + appSettings.hrms_db + `.payroll_log
                SET freeze_status = '${req.freezStatus}'
                WHERE payroll_month = '${req.years}'`;
            const resData = await manager.query(dataQuery);

            if (resData) {
                return new CommonResponse(true, 10001, "Freeze Status Updated Successfully", resData);
            }

        } catch (error) {
            return new CommonResponse(false, 11111, "Freeze Status Not Updated");
        }
    }



    async earningsExcelUpload(formData: any): Promise<CommonResponse> {
        console.log(formData, 'Received Form Data');
        const transactionManager = new GenericTransactionManager();
        const missingEmployeeCodes: string[] = [];
        try {
            await transactionManager.startTransaction();
            const flag = new Set<boolean>();
            const columnArray = [];
            const requiredColumns = ["EmployeeCode", "Earnings"]; // Required columns for validation

            const updatedArray = formData.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const newKey = key
                        .replace(/\s/g, '')
                        .replace(/[\(\)\.]/g, '')
                        .replace(/-/g, '');
                    if (newKey != '') {
                        columnArray.push(newKey);
                        updatedObj[newKey] = obj[key];
                    }
                }
                return updatedObj;
            });

            // Check for missing columns
            for (const column of requiredColumns) {
                if (!columnArray.includes(column)) {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 1111, `Missing required column: ${column}`);
                }
            }

            const convertedData = updatedArray.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const value = obj[key];
                    updatedObj[key] = value === '' ? null : value;
                }
                return updatedObj;
            });

            // Validate each row
            for (const data of convertedData) {
                if (!data.EmployeeCode) {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 1112, 'Missing EmployeeCode in one of the rows');
                }
                if (data.Earnings != null && typeof data.Earnings !== 'number') {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 1113, 'Invalid Earnings value');
                }

            }


            await transactionManager.getRepository(PayrollComponents).update(
                {},
                { earnings: 0 }
            );

            for (const data of convertedData) {
                if (data.EmployeeCode != null) {
                    const existedData = await this.payrollProcessRepo.findOne({
                        where: { employeeCode: data.EmployeeCode },
                    });

                    if (existedData) {
                        const update = await transactionManager
                            .getRepository(PayrollComponents)
                            .update({ id: existedData.id }, {
                                earnings: data.Earnings,

                            });

                        if (!update.affected) {
                            flag.add(false);
                            await transactionManager.releaseTransaction();
                            return new CommonResponse(
                                false,
                                0,
                                'Failed to update the existing record'
                            );
                        } else {
                            const logs = [];

                            if (data.Earnings != null) {
                                const messLog = new PayrollComponentsLogs();
                                messLog.employeeId = existedData.employeeId;
                                messLog.employeeName = existedData.employeeName;
                                messLog.employeeCode = existedData.employeeCode;
                                messLog.employeeType = existedData.employeeType;
                                messLog.employeeCategory = existedData.employeeCategory;
                                messLog.designation = existedData.designation;
                                messLog.department = existedData.department
                                messLog.transactionName = 'earnings';
                                messLog.type = 'other_earnings'; // Deduction
                                messLog.amount = data.Earnings;
                                logs.push(messLog);
                            }


                            const logsSaved = await transactionManager
                                .getRepository(PayrollComponentsLogs)
                                .save(logs);

                            if (logsSaved) {
                                flag.add(true);
                            } else {
                                flag.add(false);
                                await transactionManager.releaseTransaction();
                                break;
                            }
                        }
                    } else {
                        // Track missing employee codes
                        missingEmployeeCodes.push(data.EmployeeCode);
                    }
                }
            }

            if (missingEmployeeCodes.length > 0) {
                await transactionManager.releaseTransaction();
                return new CommonResponse(false, 1116, `Please Fill Basic Details In Employee Payables Screen For this Employee: ${missingEmployeeCodes.join(', ')}`);
            }

            if (!flag.has(false)) {
                await transactionManager.completeTransaction();
                return new CommonResponse(true, 1, 'Data saved successfully');
            } else {
                await transactionManager.releaseTransaction();
                return new CommonResponse(false, 0, 'Something went wrong');
            }
        } catch (err) {
            await transactionManager.releaseTransaction();
            return new CommonResponse(false, 0, `Error: ${err.message}`);
        }
    }


    async getEarningsData(): Promise<CommonResponse> {
        try {
            let dataQuery = `SELECT employee_id as employeeId,earnings as earnings,
        employee_name as employeeName, employee_code as employeeCode ,des.designation, dep.dept_name as departmentName,  employee_type as employeeType
                FROM ` + appSettings.hrms_db + `.payroll_components pc
                            LEFT JOIN ${appSettings.hrms_db}.designation des 
                            ON des.designation_id = pc.designation
                            LEFT JOIN ${appSettings.masters_db}.departments dep ON dep.dept_id = pc.department`

            const rawData = await this.payrollProcessRepo.query(dataQuery);
            return new CommonResponse(true, 233, 'data retrived successfully', rawData)
        } catch (error) {
            throw error
        }
    }

    async tdsExcelUpload(formData: any): Promise<CommonResponse> {
        console.log(formData, 'Received Form Data');
        const transactionManager = new GenericTransactionManager();
        const missingEmployeeCodes: string[] = [];
        try {
            await transactionManager.startTransaction();
            const flag = new Set<boolean>();
            const columnArray = [];
            const requiredColumns = ["EmployeeCode", "TDS"]; // Required columns for validation

            const updatedArray = formData.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const newKey = key
                        .replace(/\s/g, '')
                        .replace(/[\(\)\.]/g, '')
                        .replace(/-/g, '');
                    if (newKey != '') {
                        columnArray.push(newKey);
                        updatedObj[newKey] = obj[key];
                    }
                }
                return updatedObj;
            });

            // Check for missing columns
            for (const column of requiredColumns) {
                if (!columnArray.includes(column)) {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 1111, `Missing required column: ${column}`);
                }
            }

            const convertedData = updatedArray.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const value = obj[key];
                    updatedObj[key] = value === '' ? null : value;
                }
                return updatedObj;
            });
            console.log(convertedData, '=========')

            // Validate each row
            for (const data of convertedData) {
                if (!data.EmployeeCode) {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 1112, 'Missing EmployeeCode in one of the rows');
                }
                if (data.Earnings != null && typeof data.Earnings !== 'number') {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 1113, 'Invalid TDS value');
                }

            }


            await transactionManager.getRepository(PayrollComponents).update(
                {},
                { earnings: 0 }
            );

            for (const data of convertedData) {
                console.log(data, '---------gggdg')
                if (data.EmployeeCode != null) {
                    const existedData = await this.payrollProcessRepo.findOne({ where: { employeeCode: data.EmployeeCode }, });
                    console.log(existedData, '----------------------------------')
                    if (existedData) {
                        const update = await transactionManager.getRepository(PayrollComponents)
                            .update({ id: existedData.id }, { tds: data.TDS, });

                        if (!update.affected) {
                            flag.add(false);
                            await transactionManager.releaseTransaction();
                            return new CommonResponse(
                                false,
                                0,
                                'Failed to update the existing record'
                            );
                        } else {
                            const logs = [];

                            if (data.TDS != null) {
                                const messLog = new PayrollComponentsLogs();
                                messLog.employeeId = existedData.employeeId;
                                messLog.employeeName = existedData.employeeName;
                                messLog.employeeCode = existedData.employeeCode;
                                messLog.employeeType = existedData.employeeType;
                                messLog.employeeCategory = existedData.employeeCategory;
                                messLog.designation = existedData.designation;
                                messLog.department = existedData.department
                                messLog.transactionName = 'tds';
                                messLog.type = 'other_earnings'; // Deduction
                                messLog.amount = data.TDS;
                                logs.push(messLog);
                            }


                            const logsSaved = await transactionManager
                                .getRepository(PayrollComponentsLogs)
                                .save(logs);

                            if (logsSaved) {
                                flag.add(true);
                            } else {
                                flag.add(false);
                                await transactionManager.releaseTransaction();
                                break;
                            }
                        }
                    } else {
                        // Track missing employee codes
                        missingEmployeeCodes.push(data.EmployeeCode);
                    }
                }
            }

            if (missingEmployeeCodes.length > 0) {
                await transactionManager.releaseTransaction();
                return new CommonResponse(false, 1116, `Please Fill Basic Details In Employee Payables Screen For this Employee: ${missingEmployeeCodes.join(', ')}`);
            }

            if (!flag.has(false)) {
                await transactionManager.completeTransaction();
                return new CommonResponse(true, 1, 'Data saved successfully');
            } else {
                await transactionManager.releaseTransaction();
                return new CommonResponse(false, 0, 'Something went wrong');
            }
        } catch (err) {
            await transactionManager.releaseTransaction();
            return new CommonResponse(false, 0, `Error: ${err.message}`);
        }
    }

    async getTdsData(): Promise<CommonResponse> {
        try {
            let dataQuery = `SELECT employee_id as employeeId,tds,employee_name as employeeName, 
            employee_code as employeeCode ,des.designation, dep.dept_name as departmentName,  employee_type as employeeType
            FROM ` + appSettings.hrms_db + `.payroll_components pc
            LEFT JOIN ${appSettings.hrms_db}.designation des ON des.designation_id = pc.designation
            LEFT JOIN ${appSettings.masters_db}.departments dep ON dep.dept_id = pc.department`

            const rawData = await this.payrollProcessRepo.query(dataQuery);
            return new CommonResponse(true, 233, 'data retrieved successfully', rawData)
        } catch (error) {
            throw error
        }
    }
    async getEmpTransactionReport(req: employeeIdRequest): Promise<CommonResponse> {
        try {
            let dataQuery = `SELECT pl.id,pl.employee_id,ed.employee_code AS employeeCode , CONCAT(ed.employee_name , ' ' ,ed.emp_last_name ) AS employeeName , pl.transaction_name AS transactionName ,
            pl.type,pl.amount ,pl.created_at AS createdDate , pl.created_user AS createdUser
            FROM ` + appSettings.hrms_db + `.payroll_components_log pl
            LEFT JOIN ${appSettings.masters_db}.employee_details ed ON ed.employee_id = pl.employee_id where pl.id>0`
            if (req?.employeeId) {
                dataQuery = dataQuery + ' and pl.employee_id = ' + req?.employeeId;
            }
            const rawData = await this.payrollProcessRepo.query(dataQuery);
            return new CommonResponse(true, 233, 'data retrieved successfully', rawData)
        } catch (error) {
            throw error
        }
    }
    async getEmpInTransaction(): Promise<CommonResponse> {
        try {
            let dataQuery = `SELECT pl.id,pl.employee_id,ed.employee_code AS employeeCode , CONCAT(ed.employee_name , ' ' ,ed.emp_last_name ) AS employeeName , pl.transaction_name AS transactionName ,
            pl.type,pl.amount ,pl.created_at AS createdDate , pl.created_user AS createdUser
            FROM ` + appSettings.hrms_db + `.payroll_components_log pl
            LEFT JOIN ${appSettings.masters_db}.employee_details ed ON ed.employee_id = pl.employee_id where pl.employee_id > 0 GROUP BY pl.employee_id `
            const rawData = await this.payrollProcessRepo.query(dataQuery);
            return new CommonResponse(true, 233, 'data retrieved successfully', rawData)
        } catch (error) {
            throw error
        }
    }
}